import React, { useMemo } from 'react'
import { Challenge } from 'data/contracts'
import { sortByAvailability } from 'sharedKernel/handlers'
import { ChallengeCard } from '../ChallengeCard'
import { isChallengeClosed } from '../isChallengeClosed'
import { ChallengeContainerBox, ChallengeCardSpacing } from './styles'

interface ChallengeContainerProps {
  challenges: Challenge[]
}

export const ChallengeContainer = ({ challenges }: ChallengeContainerProps): JSX.Element => {
  const sortedChallenges = useMemo(
    () =>
      sortByAvailability(
        challenges,
        isChallengeClosed,
        (challenge) => challenge.applicationForm?.finalSelectionDate
      ),
    [challenges]
  )

  return (
    <ChallengeContainerBox>
      {sortedChallenges.map((challenge) => (
        <div key={challenge.id}>
          <ChallengeCardSpacing>
            <ChallengeCard challenge={challenge} />
          </ChallengeCardSpacing>
        </div>
      ))}
    </ChallengeContainerBox>
  )
}
